<template>
  <div class="error-container">
    <div class="error-message md:md-error-message">
      {{ $store.state.errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
};
</script>

<style scoped>
.error-container {
  background-color: crimson;
  color: white;
  position: absolute;
  top: 0;
}

.error-message {
  margin: 15px;
}

@responsive {
  .md-error-message {
    font-size: 0.81em;
  }
}
</style>
